// @flow
import React from 'react'

import StringEnumRef from './StringEnumRef'
import Radio from './Radio'

// types
import type { ResourcesType } from '../../Types/Resources'
import type { DefaultFormFieldState, DefaultFormFieldType } from './AbstractFormField'
import Popover from '../Popover'

type RadioRefSelectProps = DefaultFormFieldType & {
  domain: {
    _type: string,
    values: Array<string>,
    resourceName: string,
  },
  options: any,
  resources: ResourcesType,
  value: {
    [key: string]: string,
  },
}

type SelectedValue = {
  [key: string]: string,
}

type RadioRefSelectState = DefaultFormFieldState & {
  options?: Array<SelectedValue>,
  prevPropsValue: string,
  parentName: string,
}

export default class RadioRefSelect extends StringEnumRef<RadioRefSelectProps, RadioRefSelectState> {
  handleOnChange = (value: string) => {
    this.props.onChange(value)
  }

  render() {
    const { id, prefix, textMode, value, inputHelps } = this.props
    const { labels, options } = this.state

    if (textMode) {
      let label = value
      if (labels && labels[value]) {
        label = labels[value]
      }
      return <span>{label}</span>
    }

    const classes = []
    if (this.hasErrors() && !this.isPristine()) {
      classes.push('is-invalid')
    }

    return (
      <div className="d-md-flex d-xl-block align-items-center">
        <ul className="list list-in-row child-mb-0 small-spacing">
          {options.map((option) => (
            <li className="py-2" key={`${prefix}${id}-${option.value}`}>
              <Radio
                checked={`${value}` === `${option.value}`}
                enabled
                id={`${prefix}${id}${option.label}`}
                inputHelps={inputHelps}
                label={parseInt(option.label, 10) ? `${option.label}%` : option.label} // TODO: refactor
                name={`${prefix}${id}`}
                onChange={this.handleOnChange}
                value={option.value}
              />
            </li>
          ))}
        </ul>
      </div>
    )
  }
}
